export const isIos = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export function isReactWebview() {
  return !!window.ReactNativeWebView;
}